<template>
    <div class="wb-sidebar-categories-item" @click="$emit('click', $event)"
         :class="{
            'wb-sidebar-categories-item-active': isSelected, //TODO
            'wb-sidebar-categories-item-disabled': false //TODO
        }">
        <img class="wb-sidebar-categories-item-img" :src="img" draggable="false">
        <div class="wb-sidebar-categories-item-text">
            {{text}}
        </div>
    </div>
</template>

<script>
import { getImageHandler, getStaticImage } from '@/lib/getImage';
import { categoriesSectionsKeys } from '@/Constants/common';

export default {
    name: 'SidebarCategoriesItem',
    emits: [ 'click' ],
    props: [
        'data',
        'isSelected',
        'type',
    ],
    computed: {
        text() {
            if (this.data.name) {
                return this.data.name;
            }
            return 'Text';
        },
        img() {
            if (categoriesSectionsKeys[this.type] === 'catalog') {
                return getImageHandler(this.data.preview);
            } else {
                return getStaticImage(this.data.preview);
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/common.scss";
@import "CSS/animations.scss";

.wb-sidebar-categories-item {
    padding: 8px 8px 16px 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    color: $white;
    @include wb-c-flex-center;
}

.wb-sidebar-categories-item:hover {
    outline: 2px solid $green1;
    color: $green1;
}

.wb-sidebar-categories-item-active {
    color: $green1 !important;
    background-color: $white !important;
    outline: none !important;
}

.wb-sidebar-categories-item-disabled {
    color: $white !important;
    opacity: 0.2 !important;
    outline: none !important;
    cursor: not-allowed;
}

.wb-sidebar-categories-item-img {
    width: 80px;
    height: 80px;
    object-fit: contain;

    //TODO temp
    //background-color: #f2f2f210;
}

.wb-sidebar-categories-item-text {
    @include font-t1;
    text-align: center;
}
</style>
